import { ReactElement, useEffect, useState } from 'react'
import OverallPerformanceCard from './OverallPerformanceCard'
import { AssessmentWrapper } from '../subcomponents'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'
import { getScheuledTests, getAttemptedTests, updateStatus } from '../../../redux/test/action'
import { FlexWrapper, IconButton, Loader, SectionTitle } from '../../../components'
import strings from '../../../locale/en'
import TestTypeWrapper from './TestTypeWrapper'
import { ICONS } from '../../../const/icons'
import { TestWrapper } from './subcomponents'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../const/routes'

const Assessment = (): ReactElement => {
  const {
    selectedBatch = '',
    studentId = '',
    scheduledTests = [],
    fullLengthTests = [],
    sectionWiseTests = [],
    chapterWiseTests = [],
    isLoading
  } = useSelector(
    (state: RootState) => ({
      selectedBatch: state.user.selectedBatch,
      studentId: state.user?.userInfo?.userDetail?.usersId,
      scheduledTests: state.test?.scheuledTests,
      attemptedTests: state.test?.attemptedTests,
      attemptedChapterTests: state.test?.attemptedChapterTests,
      fullLengthTests: state.test?.fullLengthTests,
      sectionWiseTests: state.test?.sectionWiseTests,
      chapterWiseTests: state.test?.chapterWiseTests,
      isLoading: state.test?.isLoading
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const [testType, setTestType] = useState('')
  const {
    assessment: { fullLength, sectionWise, chapterWise, mock }
  } = strings

  useEffect(() => {
    if (selectedBatch) {
      dispatch(
        getScheuledTests({ batchId: selectedBatch, studentId: studentId })
      )
      dispatch(
        getAttemptedTests({ batchId: selectedBatch, studentId: studentId })
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBatch])

  const determineScheduledTests = () => {
    switch (testType) {
      case 'Full Length':
        return fullLengthTests
      case 'Chapter Wise':
        return chapterWiseTests
      case 'Section Wise':
        return sectionWiseTests
      default:
        return scheduledTests
    }
  }

  return (
    <AssessmentWrapper id="container">
      {testType ? (
        <TestTypeWrapper
          title={testType}
          scheduledTests={determineScheduledTests()}
          handleBack={() => setTestType('')}
        />
      ) : (
        <>
          <OverallPerformanceCard />
          <TestWrapper>
            <SectionTitle title={strings.assessment.scheduledTests} />
            <FlexWrapper noPadding>
              {!!fullLengthTests?.length && (
                <IconButton
                  src={ICONS.SCHEDULEDTEST}
                  isBold
                  title={fullLength}
                  onSubmit={() => {
                    setTestType(fullLength)
                  }}
                />
              )}
              {!!sectionWiseTests?.length && (
                <IconButton
                  src={ICONS.SCHEDULEDTEST}
                  isBold
                  title={sectionWise}
                  onSubmit={() => {
                    setTestType(sectionWise)
                  }}
                />
              )}
              {!!chapterWiseTests?.length && (
                <IconButton
                  src={ICONS.CHAPTER}
                  isBold
                  title={chapterWise}
                  onSubmit={() => {
                    setTestType(chapterWise)
                  }}
                />
              )}
              {!!scheduledTests?.length && (
                <IconButton
                  src={ICONS.MOCK}
                  isBold
                  title={mock}
                  onSubmit={() => {
                    setTestType(mock)
                  }}
                />
              )}
            </FlexWrapper>
            <TestWrapper>
              <SectionTitle title={strings.assessment.attemptedTests} />
              {isLoading ? (<Loader />) : (
                <FlexWrapper>
                  <IconButton
                    src={ICONS.CHAPTER}
                    isBold
                    title={'Chapter Wise'}
                    onSubmit={() => {
                      history.push(ROUTES.ATTEMPETD_TEST)
                      dispatch(updateStatus('CHAPTER'))
                    }}
                  />
                  <IconButton
                    src={ICONS.MOCK}
                    isBold
                    title={'Mock'}
                    onSubmit={() => {
                      history.push(ROUTES.ATTEMPETD_TEST)
                      dispatch(updateStatus('MOCK'))
                    }}
                  />
                </FlexWrapper>
              )}
            </TestWrapper>
          </TestWrapper>
        </>
      )}
    </AssessmentWrapper>
  )
}

export default Assessment
